// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"120":"54e4f1b6","727":"969418b0","787":"46e42000"}[chunkId] + ".chunk.js";
};